<template>

    <v-dialog 
        v-model="open" 
        max-width="360px" 
        transition="slide-y-transition" 
        :persistent="true">
        
        <div class="black-bg">
            
            <div class="dialog">
                <h4 class="main-title text-center">{{msg}}</h4>
                <v-row justify="center" class="py-4">
                    <v-icon style="main-icon" size="60" color="primary">mdi-comment-remove-outline</v-icon>
                </v-row>
                <v-btn block color="primary" @click="backtoForm">
                    Voltar
                </v-btn>
            </div>

        </div>

    </v-dialog>

</template>

<script>

export default {
    name: "endConfirm",
    data: () => ({
        open: true,
        isLoading: true,
        msg: "Não foi possivel localizar a sala",
        error: true,
        localConfig: {}
    }),
    mounted(){
        this.localConfig = JSON.parse(localStorage.getItem('@bsi:config'));
    },
    watch: {
        open: {
            handler(newValue){
                if(!newValue) this.$emit("closeModal");
            }
        }
    },
    sockets:{
      atendimentos_finish: function({error}){
        if(!error) this.error = false;
      }
    },
    methods: {
        close(){
            this.$emit("closeModal");
        },
        backtoForm(){
            const { roomID } = this.$route.params;
            this.$router.push({name: 'Signin'});
        }
    }
}

</script>

<style lang="scss">

    .v-dialog{
        position: relative;
        overflow: hidden;

        .black-bg{
            background-color: var(--v-secondary-base);
        }

        .close{
            display: block;
            margin-left: auto;
            padding: 10px;
          
        }
      
    }

</style>